import { mix, observable } from "@chorda/core";
export const FaSvgIcon = (props) => {
    return mix({
        tag: 'i',
        css: 'icon',
        templates: {
            svg: {
                tag: 'svg',
                css: 'svg-inline--fa',
                dom: {
                    // 'data-icon': props.icon.iconName,
                    // 'data-prefix': props.icon.prefix,
                    viewBox: '0 0 512 512'
                },
                templates: {
                    path: {
                        tag: 'path',
                        // dom: {
                        //     d: props.icon.icon[4]
                        // },
                        reactions: {
                            data: (v) => ({
                                dom: {
                                    d: v.icon[4]
                                }
                            })
                        }
                    }
                },
                reactions: {
                    data: (v) => {
                        return ({
                            dom: {
                                'data-icon': v.iconName,
                                'data-prefix': v.prefix,
                                'viewBox': `0 0 ${v.icon[0]} ${v.icon[1]}`
                            }
                        });
                    }
                }
            }
        },
        reactions: {
            tooltip: (v) => ({ dom: { title: v } })
        }
    }, props && {
        defaults: {
            data: () => observable(props.icon)
        },
        injections: {
            //            data: (scope, ctx) => observable(props.icon),
            tooltip: props.tooltip$,
            data: props.data$
        },
        dom: {
            title: props.tooltip
        }
    });
};
